export default __webpack_public_path__ + "static/media/ward_v2_q11_12.35162381.png";